import { CallStats, StatsCommon } from '#common/stats';
export class ServerSessionStats extends StatsCommon {
    establishSession;
    constructor(log) {
        super();
        this.establishSession = new CallStats('establishSession', log);
    }
}
